import { Button } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type WaZoneErrorBannerProps = {
  onRetry: () => void;
};

export const WaZoneErrorBanner: FC<WaZoneErrorBannerProps> = ({ onRetry }) => {
  const { t } = useTranslation('comuni');

  return (
    <div className='flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3'>
      <p className='text-sm text-amber-900'>{t('modelli.waLoadError')}</p>
      <Button intent='secondary' size='sm' text={t('modelli.waRetry')} onClick={onRetry} />
    </div>
  );
};
